import { render } from "./foot.vue?vue&type=template&id=05c492b2&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=05c492b2&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c492b2"]])

export default __exports__